module.exports = __webpack_public_path__ + "static/fonts/DaimlerCAC-Regular.fb54a956.woff";